import { TThunkAction } from '../../types/redux';
import { setFlow } from './flowActionTypes';
import { ENewReviewFlow } from '../../types/newReview';
import { clearDataNewReviewFormAction } from './newReviewsAction';

export function selectFlow(flow: ENewReviewFlow): TThunkAction<void> {
  return (dispatch, getState) => {
    const {
      newReview: {
        meta: { flow: flowFromState },
      },
    } = getState();
    if (flowFromState !== flow) {
      dispatch(clearDataNewReviewFormAction());
    }

    dispatch(setFlow(flow));
  };
}
